import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    certificados:[]
}
const GET_CERTIFICADOS_OC = 'GET_CERTIFICADOS_OC'

export const ObtenerCertificadosBeneficiario = createAsyncThunk(
    GET_CERTIFICADOS_OC,
    async (idlogin) => {
        try {
            const fullUrl = host + `SolicitudesEstatus/obtenerCertificadosBeneficiarios/${idlogin}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)
export const metodosOficiosBeneficiarioOCSlice = createSlice({

    name: 'metodosOficiosBeneficiarioOCSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
        [ObtenerCertificadosBeneficiario.fulfilled]: (state, { payload }) => {
            state.certificados = payload
        },
    },

})


export const { } = metodosOficiosBeneficiarioOCSlice.actions
export const OficiosBeneficiarioOCReducer = metodosOficiosBeneficiarioOCSlice.reducer